module.exports = __webpack_public_path__ + "static/media/Original Korean Article from - TATHAGATA - message - bookchukil2.cedb8c90.pdf";